<template>
  <!-- {{ value }} -->
  <div class="details-card">
    <b-row>
      <b-col lg="3" md="3" sm="6" cols="12">
        <div class="field">
          <CustomDropDown :label="$t('Package.department')" name="department" @update:modelValue="departmentdataemit"
            :items="isFormList.MasterDepartment" :required-icon="true" :rules="{ required: true }"
            v-model="departmentIds.MasterDepartmentId" />
        </div>
      </b-col>
      <b-col lg="3" md="3" sm="6" cols="12">
        <div class="field">
          <CustomDropDown :label="$t('Package.subdepartment')" name="subdepartment" :required-icon="true"
            :rules="{ required: true }" :items="isFormList.SubDepartment" @update:modelValue="departmentdataemit"
            v-model="departmentIds.SubDepartmentId" />
        </div>
      </b-col>
      <b-col lg="3" md="3" sm="6" cols="12">
        <div class="field">
          <CustomDropDown :label="$t('Package.category')" name="category" :required-icon="true"
            :rules="{ required: true }" :items="isFormList.MasterCategory" @update:modelValue="departmentdataemit"
            v-model="departmentIds.MasterCategoryId" />
        </div>
      </b-col>
      <b-col lg="3" md="3" sm="6" cols="12">
        <div class="field">
          <CustomDropDown :label="$t('Package.subcategory')" name="subcategory" :required-icon="true"
            :rules="{ required: true }" :items="isFormList.MasterSubCategory"
            v-model="departmentIds.MasterSubCategoryId" @update:modelValue="departmentdataemit" />
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script lang="ts">
import { defineComponent, ref, reactive, toRefs, onMounted, watch } from "vue";
import CustomDropDown from "../../../../components/FormComponents/Dropdown.vue";
import common from "../../Service/CommonService";

export default defineComponent({
  components: {
    CustomDropDown,
  },
  props: {
    value: {},
  },
  setup(props, { emit }) {
    let session: any = localStorage.getItem("UsersData");

    session = JSON.parse(session);
    let HospitalId = Number(session.HospitalId);
    let BranchId = Number(session.BranchId);
    let UserId = Number(session.UserId);
    let StoreId = Number(0);
    let HospitalCode = session.HospitalCode;
    let HospitalBranchId = Number(session.HospitalBranchId);

    let OrganizationId = Number(session.OrganizationId);

    let departmentIds = reactive({
      MasterCategoryId: ref(),
      MasterSubCategoryId: ref(),
      MasterDepartmentId: ref(),
      SubDepartmentId: ref(),
    });
    let isFormList = ref({
      MasterCategory: ref([]),
      MasterSubCategory: ref([]),
      MasterDepartment: ref([]),
      SubDepartment: ref([]),
    });
    function departmentdataemit() {
      // LoadSubdepartmentList()
      // LoadSubCategoryList()
      emit("update:modelValue", departmentIds);
    }
    onMounted(() => {
      LoaddepartmentList();
      LoadCategoryList();

      Object.assign(departmentIds, props.value);
      departmentdataemit();
    });
    watch(
      () => props.value,
      (newVal) => {
        debugger;
        //AddData.value.push(props.requestdata);'
        Object.assign(departmentIds, props.value);
        // // serviceList.value = props.value\
        // alert(props.value!['MasterSubCategoryId'])
        // isFormcomponent.value.MasterDepartmentId = props.value!['MasterSubCategoryId']
        // isFormcomponent.value.SubDepartmentId = props.value.SubDepartmentId
        // isFormcomponent.value.MasterCategoryId = props.value.MasterCategoryId
        // isFormcomponent.value.MasterSubCategoryId = props.value.MasterSubCategoryId
      }
    );
    watch(
      () => departmentIds.MasterDepartmentId,
      (newVal) => {
        LoadSubdepartmentList();
        debugger;
      }
    );
    watch(
      () => departmentIds.MasterCategoryId,
      (newVal) => {
        LoadSubCategoryList();
        debugger;
      }
    );
    async function LoaddepartmentList() {
      try {
        debugger
        const dataresponse = await common.departmentList(
          HospitalCode,
          OrganizationId
        );
        isFormList.value.MasterDepartment = dataresponse["result"].Table
          // .filter((i1) => i1.IsActive == true && i1.HospitalId == HospitalId && i1.BranchId == BranchId)
          .map((item) => {
            item.name = item.name;
            item.value = item.master_category_department_id;
            return item;
          });
      } catch (error) {
        alert(error);
      }
    }
    async function LoadSubdepartmentList() {
      try {
        const dataresponse = await common.subDepartmentList(
          departmentIds.MasterDepartmentId,
          OrganizationId
        );
        isFormList.value.SubDepartment = dataresponse["result"].Table
          // .filter((i1) => i1.IsActive == true && i1.HospitalId == HospitalId && i1.BranchId == BranchId)
          .map((item) => {
            item.name = item.sub_cd_name;
            item.value = item.sub_category_department_id;
            return item;
          });
      } catch (error) {
        alert(error);
      }
    }
    async function LoadCategoryList() {
      try {
        debugger
        const dataresponse = await common.categoryListHMS(
          HospitalCode,
          OrganizationId
        );
        isFormList.value.MasterCategory = dataresponse["result"].Table.map(
          (item) => {
            item.name = item.name;
            item.value = item.master_category_department_id;
            return item;
          }
        );
      } catch (error) {
        alert(error);
      }
    }
    async function LoadSubCategoryList() {
      try {
        const dataresponse = await common.subCategoryListHMS(
          departmentIds.MasterCategoryId,
          OrganizationId
        );
        isFormList.value.MasterSubCategory = dataresponse["result"].Table.map(
          (item) => {
            item.name = item.sub_cd_name;
            item.value = item.sub_category_department_id;
            return item;
          }
        );
      } catch (error) {
        alert(error);
      }
    }
    return {
      isFormList,
      departmentIds,
      departmentdataemit,
    };
  },
});
</script>
